import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App'; 
import { LanguageProvider } from './LanguageContext'; // <-- NY: Importerar molnet!

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> 
      <LanguageProvider> {/* <-- NY: Slår in hela appen i språkmolnet */}
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);